<template>
  <div style="display: flex">
    <country-flag
      :country="from"
      v-if="from !== 'ww'"
      style="border-radius: 8px; margin: 0"
    />
    <!-- <v-icon v-if="from === 'ww'" style="margin: 0 14px" color="primary">
      mdi-earth
    </v-icon> -->
    <v-icon v-if="from === 'ww'" style="margin: 7px 14px" color="primary">
      mdi-earth
    </v-icon>
  </div>
</template>

<script>
import CountryFlag from "vue-country-flag";

export default {
  data() {
    return {};
  },
  components: {
    CountryFlag,
  },
  props: {
    from: String,
  },
};
</script>